import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';
import { TServerSendResponse } from 'js/hooks/socket/types';
import { useUserSelector } from 'js/store/hooks';
import { prop } from 'ramda';

export const useNotifyActionStatus = () => {
    const send = useGenericSend();
    const storedWindowSessionId = useUserSelector(prop('windowSessionId'));

    return useCallback(async (request: Types.INotifyActionStatusRequestData) =>
        await send<Types.INotifyActionStatusRequestData, TServerSendResponse>({
            ID: 35808,
            responses: [35809, 35810],
            description: 'Notify Action Status',
            windowSessionId: String(storedWindowSessionId),
            ...request
        }), [send, storedWindowSessionId]);
};
